import React, { useEffect, useState } from "react";
import { Tabs, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import InnerImgCards from "./InnerImgCards";
import images from "../../themes/appImage";
import { useDispatch, useSelector } from "react-redux";
import { adminInnerCircleDetailLoad } from "../../redux/slices/adminInner.slice";
import { imageURL } from "../../redux/Api/apikit";

const SERVER_URL = imageURL;

const InnerCircleCard = ({ id, myid }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const circle = {
      circle: id,
      organisation: myid
    };
    dispatch(adminInnerCircleDetailLoad(circle));
  }, [dispatch, id]);

  const navigate = useNavigate();
  const { innerCircleDetails } = useSelector((state) => state.adminInnerReducer);

  const items = [
    {
      id: 2,
      label: "Feed",
      children: <InnerImgCards userListDetailId={id} myid={myid} />,
    },
  ];

  const onChange = () => { };

  const circleName = innerCircleDetails?.[0]?.name || "Circle Name";
  const circleMembers = innerCircleDetails?.[0]?.circleMembers || [];
  const totalMembersCount = circleMembers.length;
  const remainingImagesCount = totalMembersCount > 3 ? totalMembersCount - 3 : 0;

  const [showAllImages, setShowAllImages] = useState(false);

  const handleShowAllImages = () => {
    setShowAllImages(true);
  };

  return (
    <div className="border border-royalPurple p-6 rounded-[10px] bg-white">
      <div className="flex justify-between items-center">
        <div onClick={() => navigate(-1, {
          state: myid
        })} className="cursor-pointer">
          <img src={images.ArrowLeft} alt="arrow-left" />
        </div>
        <div>
          <div className="text-base text-center font-semibold">{circleName}</div>
          <div className="flex">
            {circleMembers.slice(0, 3).map((member, index) => (
              member.user?.avatar ? (
                <Tooltip title={member.user?.userName} placement="bottom" key={index}>
                  <img
                    src={`${SERVER_URL}${member.user.avatar}`}
                    alt={`avatar-${index}`}
                    style={{ objectFit: "contain", width: "36px", height: "36px" }}
                  />
                </Tooltip>
              ) : null
            ))}
            {remainingImagesCount > 0 && !showAllImages && (
              <div
                className="flex items-center justify-center bg-white text-dark border border-royalPurple w-[26px] h-[26px] font-xs p-4 rounded-full cursor-pointer"
                onClick={handleShowAllImages}
              >
                <Tooltip title={`+${remainingImagesCount} more`} placement="bottom">
                  +{remainingImagesCount}
                </Tooltip>
              </div>
            )}
            {showAllImages &&
              circleMembers.map((member, index) => (
                member.user?.avatar ? (
                  <Tooltip title={member.user?.userName} placement="bottom" key={index}>
                    <img
                      src={`${SERVER_URL}${member.user.avatar}`}
                      alt={`avatar-${index}`}
                      style={{ objectFit: "contain", width: "36px", height: "36px" }}
                    />
                  </Tooltip>
                ) : null
              ))}
          </div>
        </div>
        <div></div>
      </div>

      <div className="py-6">
        <Tabs
          onChange={onChange}
          type="card"
          items={items.map((item) => {
            return {
              label: item.label,
              key: item.id,
              children: item.children,
            };
          })}
        />
      </div>

    </div>

  );
};

export default InnerCircleCard;
